import { useCallback, useState } from 'react';
import { fetchCommentsCached, updateCommentsCache } from '../api/Commenting';
import useCollaborationSidebarState from './useCollaborationSidebarState';
export default function useFetchComments() {
  const [comments, setComments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();
  const {
    onUpdateCollaborationSidebarState,
    modulesWithReplies
  } = useCollaborationSidebarState();
  const fetchComments = useCallback(({
    objectType,
    objectId,
    refetch
  }) => {
    if (!objectId) {
      return;
    }
    setLoading(true);
    fetchCommentsCached({
      objectType,
      objectId,
      refetch
    }).then(({
      results
    }) => {
      // MSW will return undefined in some of our client apps
      // until we mock the client apps response we fallback to an empty array.
      // This won't impact the apps behaviour because the real API will always return
      // an array.
      setComments(results || []);
    }).catch(e => {
      setError(e);
    }).finally(() => {
      setLoading(false);
    });
  }, []);
  const updateCache = useCallback(({
    objectType,
    objectId,
    updatedCommentId
  }) => {
    const updatedComments = comments.map(comment => {
      if (comment.id === updatedCommentId) {
        return Object.assign({}, comment, {
          read: true
        });
      }
      return comment;
    });
    setComments(updatedComments);
    updateCommentsCache({
      objectType,
      objectId,
      updatedCommentId,
      comments: updatedComments,
      modulesWithReplies,
      onUpdateCollaborationSidebarState
    });
  }, [comments, modulesWithReplies, onUpdateCollaborationSidebarState]);
  return {
    fetchComments,
    comments,
    error,
    loading,
    updateCache
  };
}